export const generateOrderNumber = (order_id) => {
  return `905${String(order_id).padStart(6, "0")}`;
};
